export default "__VITE_ASSET__38ca55fe__"